// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === УНІКАЛЬНІ СТИЛІ ДЛЯ ВСІХ КОРИСТУВАЧІВ === */

/* Основний контейнер - унікальний */
.all-users-container {
    padding: 20px;
    background-color: #f5f5f5;
    min-height: 100vh;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
  }
  
  /* Заголовок сторінки */
  .all-users-header {
    margin-bottom: 30px;
  }
  
  .all-users-title {
    font-size: 28px;
    font-weight: 600;
    color: #2d3748;
    margin: 0 0 10px 0;
  }
  
  .all-users-subtitle {
    font-size: 14px;
    color: #718096;
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    align-items: center;
  }
  
  .all-users-stats {
    background-color: #edf2f7;
    padding: 8px 16px;
    border-radius: 6px;
    font-weight: 500;
    color: #4a5568;
  }
  
  /* Секції пулів - унікальні */
  .all-users-pool-section {
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    margin-bottom: 20px;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    transition: all 0.3s ease;
  }
  
  @media (max-width: 768px) {
    .all-users-pool-section {
      padding: 15px;
      margin-bottom: 15px;
      border-radius: 10px;
    }
  }
  
  @media (max-width: 480px) {
    .all-users-pool-section {
      padding: 12px;
      margin-bottom: 12px;
    }
  }
  
  /* Заголовок пулу */
  .all-users-pool-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 2px solid #f1f1f1;
  }
  
  .all-users-pool-title {
    font-size: 22px;
    font-weight: 600;
    color: #2d3748;
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0;
    flex-wrap: wrap;
  }
  
  .all-users-server-count {
    font-size: 18px;
    color: #718096;
    font-weight: 500;
    background-color: #f7fafc;
    padding: 4px 12px;
    border-radius: 20px;
    border: 1px solid #e2e8f0;
  }
  
  /* Кнопка згортання */
  .all-users-collapse-btn {
    background: none;
    border: 1px solid #cbd5e0;
    width: 36px;
    height: 36px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    color: #4a5568;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  
  .all-users-collapse-btn:hover {
    background-color: #f7fafc;
    border-color: #a0aec0;
  }
  
  /* Список серверів */
  .all-users-servers-list {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  
  /* Картка сервера - АДАПТИВНА */
  .all-users-server-card {
    position: relative;
    background: #ffffff;
    border: 2px solid #e2e8f0;
    border-radius: 10px;
    overflow: hidden;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    min-height: 110px;
  }
  
  /* Статуси карток */
  .all-users-server-card.completed {
    background-color: #f0fff4;
    border-color: #68d391;
  }
  
  .all-users-server-card.in-progress {
    background-color: #ebf8ff;
    border-color: #63b3ed;
    border-left: 4px solid #4299e1;
  }
  
  .all-users-server-card.error {
    background-color: #fff5f5;
    border-color: #fc8181;
  }
  
  .all-users-server-card.archived {
    background-color: #f7fafc;
    border-color: #cbd5e0;
    opacity: 0.8;
  }
  
  /* Контент картки - ПОКРАЩЕНА АДАПТИВНІСТЬ */
  .all-users-server-content {
    position: relative;
    z-index: 2;
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 15px;
    padding: 16px;
    align-items: start;
    min-height: 110px;
    box-sizing: border-box;
  }
  
  @media (max-width: 768px) {
    .all-users-server-content {
      grid-template-columns: 1fr;
      gap: 12px;
      padding: 14px;
    }
  }
  
  /* Інформація про сервер */
  .all-users-server-info {
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-width: 0; /* Важливо для обрізки тексту */
  }
  
  .all-users-server-address-wrapper {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  
  .all-users-server-address {
    font-size: 18px;
    font-weight: 700;
    color: #2d3748;
    word-break: break-all; /* Дозволяє переносити довгі домени */
    line-height: 1.3;
    overflow-wrap: break-word;
    hyphens: auto;
  }
  
  .all-users-user-name-wrapper {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  
  .all-users-user-name {
    font-size: 14px;
    font-weight: 500;
    color: #4a5568;
    word-break: break-word;
    line-height: 1.4;
  }
  
  /* Рядок статусу */
  .all-users-server-status-row {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    margin-top: 5px;
  }
  
  .all-users-server-status {
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
    flex-shrink: 0;
    padding: 4px 10px;
    border-radius: 6px;
    display: inline-flex;
    align-items: center;
    gap: 5px;
  }
  
  .all-users-server-status.success {
    background-color: #c6f6d5;
    color: #22543d;
  }
  
  .all-users-server-status.progress {
    background-color: #bee3f8;
    color: #2c5282;
  }
  
  .all-users-server-status.error {
    background-color: #fed7d7;
    color: #742a2a;
  }
  
  .all-users-server-status.unknown {
    background-color: #e2e8f0;
    color: #4a5568;
  }
  
  /* Таймер */
  .all-users-server-timer {
    font-size: 13px;
    font-weight: 600;
    color: #2d3748;
    white-space: nowrap;
    background-color: #ffd700;
    padding: 4px 10px;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  }
  
  /* Дії з сервером */
  .all-users-server-actions {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    flex-shrink: 0;
  }
  
  @media (max-width: 768px) {
    .all-users-server-actions {
      justify-self: end;
      align-self: flex-end;
      width: 100%;
      justify-content: flex-end;
      margin-top: 10px;
    }
  }
  
  .all-users-detail-button {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #4299e1;
    color: white;
    border-radius: 6px;
    text-decoration: none;
    font-size: 16px;
    transition: all 0.2s;
    border: none;
    cursor: pointer;
    flex-shrink: 0;
    font-weight: bold;
  }
  
  .all-users-detail-button:hover {
    background-color: #3182ce;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  
  .all-users-archive-button,
  .all-users-unarchive-button {
    padding: 8px 16px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    transition: all 0.2s;
    white-space: nowrap;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 36px;
  }
  
  .all-users-archive-button {
    background-color: #ed8936;
    color: white;
  }
  
  .all-users-archive-button:hover {
    background-color: #dd6b20;
    transform: translateY(-1px);
  }
  
  .all-users-unarchive-button {
    background-color: #48bb78;
    color: white;
  }
  
  .all-users-unarchive-button:hover {
    background-color: #38a169;
    transform: translateY(-1px);
  }
  
  /* Перемикач виду */
  .all-users-view-toggle {
    display: flex;
    gap: 10px;
    background-color: #f7fafc;
    padding: 4px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
  }
  
  .all-users-view-toggle button {
    padding: 10px 20px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.2s;
    white-space: nowrap;
    font-size: 14px;
    background: none;
    color: #4a5568;
  }
  
  .all-users-view-toggle button.all-users-active {
    background-color: #4299e1;
    color: white;
    box-shadow: 0 2px 4px rgba(66, 153, 225, 0.3);
  }
  
  .all-users-view-toggle button:not(.all-users-active):hover {
    background-color: #e2e8f0;
  }
  
  /* Кнопка оновлення */
  .all-users-refresh-button {
    padding: 10px 20px;
    background-color: #48bb78;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.2s;
    font-size: 14px;
    white-space: nowrap;
  }
  
  .all-users-refresh-button:hover {
    background-color: #38a169;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(56, 161, 105, 0.3);
  }
  
  /* Повідомлення про відсутність даних */
  .all-users-no-data {
    text-align: center;
    padding: 40px 20px;
    color: #a0aec0;
    font-size: 16px;
    font-style: italic;
    border: 2px dashed #e2e8f0;
    border-radius: 10px;
    background-color: #fafafa;
  }
  
  /* Завантаження */
  .all-users-loading {
    text-align: center;
    padding: 60px 20px;
    color: #4a5568;
    font-size: 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
  
  .all-users-loading-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #e2e8f0;
    border-top: 4px solid #4299e1;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  /* Помилка */
  .all-users-error-message {
    background-color: #fed7d7;
    color: #742a2a;
    padding: 15px;
    margin: 15px 0;
    border-radius: 8px;
    border: 1px solid #fc8181;
    font-size: 14px;
  }
  
  /* Контейнер для кнопок */
  .all-users-column-actions {
    display: flex;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;
  }
  
  @media (max-width: 768px) {
    .all-users-column-actions {
      gap: 15px;
      width: 100%;
      justify-content: space-between;
    }
    
    .all-users-view-toggle {
      order: 2;
    }
    
    .all-users-refresh-button {
      order: 1;
    }
  }
  
  /* Адаптивність для дуже малих екранів */
  @media (max-width: 480px) {
    .all-users-container {
      padding: 10px;
    }
    
    .all-users-title {
      font-size: 24px;
    }
    
    .all-users-server-address {
      font-size: 16px;
    }
    
    .all-users-user-name {
      font-size: 13px;
    }
    
    .all-users-view-toggle button {
      padding: 8px 12px;
      font-size: 13px;
    }
    
    .all-users-refresh-button {
      padding: 8px 16px;
      font-size: 13px;
    }
    
    .all-users-server-actions {
      gap: 8px;
    }
    
    .all-users-archive-button,
    .all-users-unarchive-button {
      padding: 6px 12px;
      font-size: 12px;
      height: 32px;
    }
    
    .all-users-detail-button {
      width: 32px;
      height: 32px;
    }
  }
  
  /* Стиль для спливаючого вікна */
  .all-users-pip-controls {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
  }
  
  .all-users-pip-toggle-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    padding: 10px 16px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.2s ease;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    color: #4a5568;
  }
  
  .all-users-pip-toggle-btn:hover {
    background: #f8fafc;
    border-color: #cbd5e0;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  }

  /* InstallAll.css - Додати ці стилі */

/* Фільтри */
.all-users-filters {
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  }
  
  .all-users-filter-group {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
  }
  
  .all-users-filter-input,
  .all-users-filter-date,
  .all-users-filter-select {
    padding: 8px 12px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-size: 14px;
    min-width: 180px;
  }
  
  .all-users-filter-input {
    flex: 1 1;
    min-width: 200px;
  }
  
  .all-users-filter-date {
    width: 150px;
  }
  
  .all-users-filter-select {
    width: 150px;
    background-color: white;
  }
  
  .all-users-filter-checkbox {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 8px 12px;
    background-color: white;
    border: 1px solid #ced4da;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .all-users-filter-checkbox:hover {
    background-color: #f8f9fa;
  }
  
  .all-users-filter-clear {
    padding: 8px 12px;
    background-color: #6c757d;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
  }
  
  .all-users-filter-clear:hover {
    background-color: #5a6268;
  }
  
  /* Кнопка порівняння */
  .all-users-compare-button {
    padding: 8px 16px;
    background-color: #ffc107;
    color: #212529;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;
    font-size: 14px;
    margin-left: 10px;
  }
  
  .all-users-compare-button:hover:not(:disabled) {
    background-color: #e0a800;
  }
  
  .all-users-compare-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  
  /* Бейдж небезпечного сервера */
  .all-users-dangerous-badge {
    display: inline-block;
    margin-left: 8px;
    background-color: #dc3545;
    color: white;
    padding: 2px 6px;
    border-radius: 10px;
    font-size: 12px;
    animation: pulse 2s infinite;
  }
  
  @keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.7; }
    100% { opacity: 1; }
  }
  
  /* Стилі для небезпечних серверів */
  .all-users-server-card.dangerous {
    border-left: 4px solid #dc3545 !important;
    background-color: #fff8f8 !important;
  }
  
  .all-users-server-card.dangerous:hover {
    background-color: #ffeaea !important;
  }
  
  .all-users-server-card.dangerous.completed {
    border-left: 4px solid #dc3545 !important;
    background-color: #fff8f8 !important;
  }
  
  .all-users-server-card.dangerous.in-progress {
    border-left: 4px solid #dc3545 !important;
    background-color: #fff8f8 !important;
  }
  
  .all-users-server-card.dangerous.error {
    border-left: 4px solid #dc3545 !important;
    background-color: #fff8f8 !important;
  }
  
  /* Інформація про небезпечні сервери */
  .all-users-dangerous-info {
    background-color: #fff3cd;
    border: 1px solid #ffeaa7;
    border-radius: 8px;
    padding: 10px 15px;
    margin-bottom: 20px;
  }
  
  .all-users-dangerous-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    color: #856404;
  }
  
  .all-users-dangerous-toggle {
    padding: 5px 10px;
    background-color: #ffc107;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
  }
  
  .all-users-dangerous-toggle:hover {
    background-color: #e0a800;
  }
  
  .all-users-dangerous-count {
    margin-left: 10px;
    background-color: #dc3545;
    color: white;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
  }
  
  /* Адаптивність */
  @media (max-width: 768px) {
    .all-users-filter-group {
      flex-direction: column;
      align-items: stretch;
    }
    
    .all-users-filter-input,
    .all-users-filter-date,
    .all-users-filter-select,
    .all-users-filter-checkbox {
      width: 100%;
    }
    
    .all-users-column-actions {
      flex-wrap: wrap;
      gap: 10px;
    }
    
    .all-users-compare-button,
    .all-users-planfix-button {
      margin-left: 0;
    }
  }
  
  /* Повідомлення */
  .all-users-message {
    padding: 10px 15px;
    margin-bottom: 15px;
    border-radius: 4px;
    font-size: 14px;
  }
  
  .all-users-message.success {
    background-color: #d4edda;
    border: 1px solid #c3e6cb;
    color: #155724;
  }
  
  .all-users-message.error {
    background-color: #f8d7da;
    border: 1px solid #f5c6cb;
    color: #721c24;
  }`, "",{"version":3,"sources":["webpack://./src/components/covfile/InstallAll.css"],"names":[],"mappings":"AAAA,kDAAkD;;AAElD,oCAAoC;AACpC;IACI,aAAa;IACb,yBAAyB;IACzB,iBAAiB;IACjB,8FAA8F;EAChG;;EAEA,uBAAuB;EACvB;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,aAAa;IACb,SAAS;IACT,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;EAChB;;EAEA,6BAA6B;EAC7B;IACE,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE;MACE,aAAa;MACb,mBAAmB;MACnB,mBAAmB;IACrB;EACF;;EAEA;IACE;MACE,aAAa;MACb,mBAAmB;IACrB;EACF;;EAEA,mBAAmB;EACnB;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA,qBAAqB;EACrB;IACE,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA,oBAAoB;EACpB;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA,+BAA+B;EAC/B;IACE,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA,mBAAmB;EACnB;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;EACd;;EAEA,4CAA4C;EAC5C;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,+BAA+B;IAC/B,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE;MACE,0BAA0B;MAC1B,SAAS;MACT,aAAa;IACf;EACF;;EAEA,0BAA0B;EAC1B;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,YAAY,EAAE,+BAA+B;EAC/C;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB,EAAE,qCAAqC;IAC5D,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA,kBAAkB;EAClB;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA,WAAW;EACX;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,qCAAqC;EACvC;;EAEA,mBAAmB;EACnB;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,cAAc;EAChB;;EAEA;IACE;MACE,iBAAiB;MACjB,oBAAoB;MACpB,WAAW;MACX,yBAAyB;MACzB,gBAAgB;IAClB;EACF;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,oBAAoB;IACpB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,qCAAqC;EACvC;;EAEA;;IAEE,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA,mBAAmB;EACnB;IACE,aAAa;IACb,SAAS;IACT,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,6CAA6C;EAC/C;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,qBAAqB;EACrB;IACE,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,6CAA6C;EAC/C;;EAEA,uCAAuC;EACvC;IACE,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,0BAA0B;IAC1B,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA,iBAAiB;EACjB;IACE,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,kCAAkC;EACpC;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;;EAEA,YAAY;EACZ;IACE,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;EACjB;;EAEA,yBAAyB;EACzB;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE;MACE,SAAS;MACT,WAAW;MACX,8BAA8B;IAChC;;IAEA;MACE,QAAQ;IACV;;IAEA;MACE,QAAQ;IACV;EACF;;EAEA,wCAAwC;EACxC;IACE;MACE,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;MACjB,eAAe;IACjB;;IAEA;MACE,iBAAiB;MACjB,eAAe;IACjB;;IAEA;MACE,QAAQ;IACV;;IAEA;;MAEE,iBAAiB;MACjB,eAAe;MACf,YAAY;IACd;;IAEA;MACE,WAAW;MACX,YAAY;IACd;EACF;;EAEA,gCAAgC;EAChC;IACE,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,0CAA0C;IAC1C,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,yCAAyC;EAC3C;;EAEA,qCAAqC;;AAEvC,YAAY;AACZ;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,sCAAsC;EACxC;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;EACrB;;EAEA;;;IAGE,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,sBAAsB;EACtB;IACE,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA,+BAA+B;EAC/B;IACE,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,4BAA4B;EAC9B;;EAEA;IACE,KAAK,UAAU,EAAE;IACjB,MAAM,YAAY,EAAE;IACpB,OAAO,UAAU,EAAE;EACrB;;EAEA,mCAAmC;EACnC;IACE,yCAAyC;IACzC,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,yCAAyC;IACzC,oCAAoC;EACtC;;EAEA;IACE,yCAAyC;IACzC,oCAAoC;EACtC;;EAEA;IACE,yCAAyC;IACzC,oCAAoC;EACtC;;EAEA,sCAAsC;EACtC;IACE,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;;EAEA,iBAAiB;EACjB;IACE;MACE,sBAAsB;MACtB,oBAAoB;IACtB;;IAEA;;;;MAIE,WAAW;IACb;;IAEA;MACE,eAAe;MACf,SAAS;IACX;;IAEA;;MAEE,cAAc;IAChB;EACF;;EAEA,iBAAiB;EACjB;IACE,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;EAChB","sourcesContent":["/* === УНІКАЛЬНІ СТИЛІ ДЛЯ ВСІХ КОРИСТУВАЧІВ === */\r\n\r\n/* Основний контейнер - унікальний */\r\n.all-users-container {\r\n    padding: 20px;\r\n    background-color: #f5f5f5;\r\n    min-height: 100vh;\r\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;\r\n  }\r\n  \r\n  /* Заголовок сторінки */\r\n  .all-users-header {\r\n    margin-bottom: 30px;\r\n  }\r\n  \r\n  .all-users-title {\r\n    font-size: 28px;\r\n    font-weight: 600;\r\n    color: #2d3748;\r\n    margin: 0 0 10px 0;\r\n  }\r\n  \r\n  .all-users-subtitle {\r\n    font-size: 14px;\r\n    color: #718096;\r\n    display: flex;\r\n    gap: 20px;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n  }\r\n  \r\n  .all-users-stats {\r\n    background-color: #edf2f7;\r\n    padding: 8px 16px;\r\n    border-radius: 6px;\r\n    font-weight: 500;\r\n    color: #4a5568;\r\n  }\r\n  \r\n  /* Секції пулів - унікальні */\r\n  .all-users-pool-section {\r\n    background: white;\r\n    border-radius: 12px;\r\n    padding: 20px;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\r\n    margin-bottom: 20px;\r\n    max-width: 1200px;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    transition: all 0.3s ease;\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n    .all-users-pool-section {\r\n      padding: 15px;\r\n      margin-bottom: 15px;\r\n      border-radius: 10px;\r\n    }\r\n  }\r\n  \r\n  @media (max-width: 480px) {\r\n    .all-users-pool-section {\r\n      padding: 12px;\r\n      margin-bottom: 12px;\r\n    }\r\n  }\r\n  \r\n  /* Заголовок пулу */\r\n  .all-users-pool-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n    padding-bottom: 15px;\r\n    border-bottom: 2px solid #f1f1f1;\r\n  }\r\n  \r\n  .all-users-pool-title {\r\n    font-size: 22px;\r\n    font-weight: 600;\r\n    color: #2d3748;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    margin: 0;\r\n    flex-wrap: wrap;\r\n  }\r\n  \r\n  .all-users-server-count {\r\n    font-size: 18px;\r\n    color: #718096;\r\n    font-weight: 500;\r\n    background-color: #f7fafc;\r\n    padding: 4px 12px;\r\n    border-radius: 20px;\r\n    border: 1px solid #e2e8f0;\r\n  }\r\n  \r\n  /* Кнопка згортання */\r\n  .all-users-collapse-btn {\r\n    background: none;\r\n    border: 1px solid #cbd5e0;\r\n    width: 36px;\r\n    height: 36px;\r\n    border-radius: 6px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n    color: #4a5568;\r\n    transition: all 0.2s;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-shrink: 0;\r\n  }\r\n  \r\n  .all-users-collapse-btn:hover {\r\n    background-color: #f7fafc;\r\n    border-color: #a0aec0;\r\n  }\r\n  \r\n  /* Список серверів */\r\n  .all-users-servers-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n  }\r\n  \r\n  /* Картка сервера - АДАПТИВНА */\r\n  .all-users-server-card {\r\n    position: relative;\r\n    background: #ffffff;\r\n    border: 2px solid #e2e8f0;\r\n    border-radius: 10px;\r\n    overflow: hidden;\r\n    transition: all 0.3s ease;\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-height: 110px;\r\n  }\r\n  \r\n  /* Статуси карток */\r\n  .all-users-server-card.completed {\r\n    background-color: #f0fff4;\r\n    border-color: #68d391;\r\n  }\r\n  \r\n  .all-users-server-card.in-progress {\r\n    background-color: #ebf8ff;\r\n    border-color: #63b3ed;\r\n    border-left: 4px solid #4299e1;\r\n  }\r\n  \r\n  .all-users-server-card.error {\r\n    background-color: #fff5f5;\r\n    border-color: #fc8181;\r\n  }\r\n  \r\n  .all-users-server-card.archived {\r\n    background-color: #f7fafc;\r\n    border-color: #cbd5e0;\r\n    opacity: 0.8;\r\n  }\r\n  \r\n  /* Контент картки - ПОКРАЩЕНА АДАПТИВНІСТЬ */\r\n  .all-users-server-content {\r\n    position: relative;\r\n    z-index: 2;\r\n    display: grid;\r\n    grid-template-columns: 1fr auto;\r\n    gap: 15px;\r\n    padding: 16px;\r\n    align-items: start;\r\n    min-height: 110px;\r\n    box-sizing: border-box;\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n    .all-users-server-content {\r\n      grid-template-columns: 1fr;\r\n      gap: 12px;\r\n      padding: 14px;\r\n    }\r\n  }\r\n  \r\n  /* Інформація про сервер */\r\n  .all-users-server-info {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    min-width: 0; /* Важливо для обрізки тексту */\r\n  }\r\n  \r\n  .all-users-server-address-wrapper {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 4px;\r\n  }\r\n  \r\n  .all-users-server-address {\r\n    font-size: 18px;\r\n    font-weight: 700;\r\n    color: #2d3748;\r\n    word-break: break-all; /* Дозволяє переносити довгі домени */\r\n    line-height: 1.3;\r\n    overflow-wrap: break-word;\r\n    hyphens: auto;\r\n  }\r\n  \r\n  .all-users-user-name-wrapper {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 4px;\r\n  }\r\n  \r\n  .all-users-user-name {\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    color: #4a5568;\r\n    word-break: break-word;\r\n    line-height: 1.4;\r\n  }\r\n  \r\n  /* Рядок статусу */\r\n  .all-users-server-status-row {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    flex-wrap: wrap;\r\n    margin-top: 5px;\r\n  }\r\n  \r\n  .all-users-server-status {\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    white-space: nowrap;\r\n    flex-shrink: 0;\r\n    padding: 4px 10px;\r\n    border-radius: 6px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n  }\r\n  \r\n  .all-users-server-status.success {\r\n    background-color: #c6f6d5;\r\n    color: #22543d;\r\n  }\r\n  \r\n  .all-users-server-status.progress {\r\n    background-color: #bee3f8;\r\n    color: #2c5282;\r\n  }\r\n  \r\n  .all-users-server-status.error {\r\n    background-color: #fed7d7;\r\n    color: #742a2a;\r\n  }\r\n  \r\n  .all-users-server-status.unknown {\r\n    background-color: #e2e8f0;\r\n    color: #4a5568;\r\n  }\r\n  \r\n  /* Таймер */\r\n  .all-users-server-timer {\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    color: #2d3748;\r\n    white-space: nowrap;\r\n    background-color: #ffd700;\r\n    padding: 4px 10px;\r\n    border-radius: 4px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    flex-shrink: 0;\r\n    box-shadow: 0 1px 3px rgba(0,0,0,0.1);\r\n  }\r\n  \r\n  /* Дії з сервером */\r\n  .all-users-server-actions {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 10px;\r\n    flex-shrink: 0;\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n    .all-users-server-actions {\r\n      justify-self: end;\r\n      align-self: flex-end;\r\n      width: 100%;\r\n      justify-content: flex-end;\r\n      margin-top: 10px;\r\n    }\r\n  }\r\n  \r\n  .all-users-detail-button {\r\n    width: 36px;\r\n    height: 36px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: #4299e1;\r\n    color: white;\r\n    border-radius: 6px;\r\n    text-decoration: none;\r\n    font-size: 16px;\r\n    transition: all 0.2s;\r\n    border: none;\r\n    cursor: pointer;\r\n    flex-shrink: 0;\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .all-users-detail-button:hover {\r\n    background-color: #3182ce;\r\n    transform: translateY(-1px);\r\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n  }\r\n  \r\n  .all-users-archive-button,\r\n  .all-users-unarchive-button {\r\n    padding: 8px 16px;\r\n    border: none;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    transition: all 0.2s;\r\n    white-space: nowrap;\r\n    flex-shrink: 0;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 36px;\r\n  }\r\n  \r\n  .all-users-archive-button {\r\n    background-color: #ed8936;\r\n    color: white;\r\n  }\r\n  \r\n  .all-users-archive-button:hover {\r\n    background-color: #dd6b20;\r\n    transform: translateY(-1px);\r\n  }\r\n  \r\n  .all-users-unarchive-button {\r\n    background-color: #48bb78;\r\n    color: white;\r\n  }\r\n  \r\n  .all-users-unarchive-button:hover {\r\n    background-color: #38a169;\r\n    transform: translateY(-1px);\r\n  }\r\n  \r\n  /* Перемикач виду */\r\n  .all-users-view-toggle {\r\n    display: flex;\r\n    gap: 10px;\r\n    background-color: #f7fafc;\r\n    padding: 4px;\r\n    border-radius: 8px;\r\n    border: 1px solid #e2e8f0;\r\n  }\r\n  \r\n  .all-users-view-toggle button {\r\n    padding: 10px 20px;\r\n    border: none;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    font-weight: 600;\r\n    transition: all 0.2s;\r\n    white-space: nowrap;\r\n    font-size: 14px;\r\n    background: none;\r\n    color: #4a5568;\r\n  }\r\n  \r\n  .all-users-view-toggle button.all-users-active {\r\n    background-color: #4299e1;\r\n    color: white;\r\n    box-shadow: 0 2px 4px rgba(66, 153, 225, 0.3);\r\n  }\r\n  \r\n  .all-users-view-toggle button:not(.all-users-active):hover {\r\n    background-color: #e2e8f0;\r\n  }\r\n  \r\n  /* Кнопка оновлення */\r\n  .all-users-refresh-button {\r\n    padding: 10px 20px;\r\n    background-color: #48bb78;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    font-weight: 600;\r\n    transition: all 0.2s;\r\n    font-size: 14px;\r\n    white-space: nowrap;\r\n  }\r\n  \r\n  .all-users-refresh-button:hover {\r\n    background-color: #38a169;\r\n    transform: translateY(-1px);\r\n    box-shadow: 0 2px 4px rgba(56, 161, 105, 0.3);\r\n  }\r\n  \r\n  /* Повідомлення про відсутність даних */\r\n  .all-users-no-data {\r\n    text-align: center;\r\n    padding: 40px 20px;\r\n    color: #a0aec0;\r\n    font-size: 16px;\r\n    font-style: italic;\r\n    border: 2px dashed #e2e8f0;\r\n    border-radius: 10px;\r\n    background-color: #fafafa;\r\n  }\r\n  \r\n  /* Завантаження */\r\n  .all-users-loading {\r\n    text-align: center;\r\n    padding: 60px 20px;\r\n    color: #4a5568;\r\n    font-size: 18px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 15px;\r\n  }\r\n  \r\n  .all-users-loading-spinner {\r\n    width: 40px;\r\n    height: 40px;\r\n    border: 4px solid #e2e8f0;\r\n    border-top: 4px solid #4299e1;\r\n    border-radius: 50%;\r\n    animation: spin 1s linear infinite;\r\n  }\r\n  \r\n  @keyframes spin {\r\n    0% { transform: rotate(0deg); }\r\n    100% { transform: rotate(360deg); }\r\n  }\r\n  \r\n  /* Помилка */\r\n  .all-users-error-message {\r\n    background-color: #fed7d7;\r\n    color: #742a2a;\r\n    padding: 15px;\r\n    margin: 15px 0;\r\n    border-radius: 8px;\r\n    border: 1px solid #fc8181;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  /* Контейнер для кнопок */\r\n  .all-users-column-actions {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 20px;\r\n    flex-wrap: wrap;\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n    .all-users-column-actions {\r\n      gap: 15px;\r\n      width: 100%;\r\n      justify-content: space-between;\r\n    }\r\n    \r\n    .all-users-view-toggle {\r\n      order: 2;\r\n    }\r\n    \r\n    .all-users-refresh-button {\r\n      order: 1;\r\n    }\r\n  }\r\n  \r\n  /* Адаптивність для дуже малих екранів */\r\n  @media (max-width: 480px) {\r\n    .all-users-container {\r\n      padding: 10px;\r\n    }\r\n    \r\n    .all-users-title {\r\n      font-size: 24px;\r\n    }\r\n    \r\n    .all-users-server-address {\r\n      font-size: 16px;\r\n    }\r\n    \r\n    .all-users-user-name {\r\n      font-size: 13px;\r\n    }\r\n    \r\n    .all-users-view-toggle button {\r\n      padding: 8px 12px;\r\n      font-size: 13px;\r\n    }\r\n    \r\n    .all-users-refresh-button {\r\n      padding: 8px 16px;\r\n      font-size: 13px;\r\n    }\r\n    \r\n    .all-users-server-actions {\r\n      gap: 8px;\r\n    }\r\n    \r\n    .all-users-archive-button,\r\n    .all-users-unarchive-button {\r\n      padding: 6px 12px;\r\n      font-size: 12px;\r\n      height: 32px;\r\n    }\r\n    \r\n    .all-users-detail-button {\r\n      width: 32px;\r\n      height: 32px;\r\n    }\r\n  }\r\n  \r\n  /* Стиль для спливаючого вікна */\r\n  .all-users-pip-controls {\r\n    position: fixed;\r\n    bottom: 20px;\r\n    right: 20px;\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .all-users-pip-toggle-btn {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    background: white;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 6px;\r\n    padding: 10px 16px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    transition: all 0.2s ease;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n    color: #4a5568;\r\n  }\r\n  \r\n  .all-users-pip-toggle-btn:hover {\r\n    background: #f8fafc;\r\n    border-color: #cbd5e0;\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);\r\n  }\r\n\r\n  /* InstallAll.css - Додати ці стилі */\r\n\r\n/* Фільтри */\r\n.all-users-filters {\r\n    background-color: #f8f9fa;\r\n    border: 1px solid #dee2e6;\r\n    border-radius: 8px;\r\n    padding: 15px;\r\n    margin-bottom: 20px;\r\n    box-shadow: 0 2px 4px rgba(0,0,0,0.05);\r\n  }\r\n  \r\n  .all-users-filter-group {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 10px;\r\n    align-items: center;\r\n  }\r\n  \r\n  .all-users-filter-input,\r\n  .all-users-filter-date,\r\n  .all-users-filter-select {\r\n    padding: 8px 12px;\r\n    border: 1px solid #ced4da;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n    min-width: 180px;\r\n  }\r\n  \r\n  .all-users-filter-input {\r\n    flex: 1;\r\n    min-width: 200px;\r\n  }\r\n  \r\n  .all-users-filter-date {\r\n    width: 150px;\r\n  }\r\n  \r\n  .all-users-filter-select {\r\n    width: 150px;\r\n    background-color: white;\r\n  }\r\n  \r\n  .all-users-filter-checkbox {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n    padding: 8px 12px;\r\n    background-color: white;\r\n    border: 1px solid #ced4da;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .all-users-filter-checkbox:hover {\r\n    background-color: #f8f9fa;\r\n  }\r\n  \r\n  .all-users-filter-clear {\r\n    padding: 8px 12px;\r\n    background-color: #6c757d;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .all-users-filter-clear:hover {\r\n    background-color: #5a6268;\r\n  }\r\n  \r\n  /* Кнопка порівняння */\r\n  .all-users-compare-button {\r\n    padding: 8px 16px;\r\n    background-color: #ffc107;\r\n    color: #212529;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-weight: bold;\r\n    font-size: 14px;\r\n    margin-left: 10px;\r\n  }\r\n  \r\n  .all-users-compare-button:hover:not(:disabled) {\r\n    background-color: #e0a800;\r\n  }\r\n  \r\n  .all-users-compare-button:disabled {\r\n    opacity: 0.6;\r\n    cursor: not-allowed;\r\n  }\r\n  \r\n  /* Бейдж небезпечного сервера */\r\n  .all-users-dangerous-badge {\r\n    display: inline-block;\r\n    margin-left: 8px;\r\n    background-color: #dc3545;\r\n    color: white;\r\n    padding: 2px 6px;\r\n    border-radius: 10px;\r\n    font-size: 12px;\r\n    animation: pulse 2s infinite;\r\n  }\r\n  \r\n  @keyframes pulse {\r\n    0% { opacity: 1; }\r\n    50% { opacity: 0.7; }\r\n    100% { opacity: 1; }\r\n  }\r\n  \r\n  /* Стилі для небезпечних серверів */\r\n  .all-users-server-card.dangerous {\r\n    border-left: 4px solid #dc3545 !important;\r\n    background-color: #fff8f8 !important;\r\n  }\r\n  \r\n  .all-users-server-card.dangerous:hover {\r\n    background-color: #ffeaea !important;\r\n  }\r\n  \r\n  .all-users-server-card.dangerous.completed {\r\n    border-left: 4px solid #dc3545 !important;\r\n    background-color: #fff8f8 !important;\r\n  }\r\n  \r\n  .all-users-server-card.dangerous.in-progress {\r\n    border-left: 4px solid #dc3545 !important;\r\n    background-color: #fff8f8 !important;\r\n  }\r\n  \r\n  .all-users-server-card.dangerous.error {\r\n    border-left: 4px solid #dc3545 !important;\r\n    background-color: #fff8f8 !important;\r\n  }\r\n  \r\n  /* Інформація про небезпечні сервери */\r\n  .all-users-dangerous-info {\r\n    background-color: #fff3cd;\r\n    border: 1px solid #ffeaa7;\r\n    border-radius: 8px;\r\n    padding: 10px 15px;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .all-users-dangerous-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    font-weight: bold;\r\n    color: #856404;\r\n  }\r\n  \r\n  .all-users-dangerous-toggle {\r\n    padding: 5px 10px;\r\n    background-color: #ffc107;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-size: 12px;\r\n  }\r\n  \r\n  .all-users-dangerous-toggle:hover {\r\n    background-color: #e0a800;\r\n  }\r\n  \r\n  .all-users-dangerous-count {\r\n    margin-left: 10px;\r\n    background-color: #dc3545;\r\n    color: white;\r\n    padding: 2px 8px;\r\n    border-radius: 12px;\r\n    font-size: 12px;\r\n  }\r\n  \r\n  /* Адаптивність */\r\n  @media (max-width: 768px) {\r\n    .all-users-filter-group {\r\n      flex-direction: column;\r\n      align-items: stretch;\r\n    }\r\n    \r\n    .all-users-filter-input,\r\n    .all-users-filter-date,\r\n    .all-users-filter-select,\r\n    .all-users-filter-checkbox {\r\n      width: 100%;\r\n    }\r\n    \r\n    .all-users-column-actions {\r\n      flex-wrap: wrap;\r\n      gap: 10px;\r\n    }\r\n    \r\n    .all-users-compare-button,\r\n    .all-users-planfix-button {\r\n      margin-left: 0;\r\n    }\r\n  }\r\n  \r\n  /* Повідомлення */\r\n  .all-users-message {\r\n    padding: 10px 15px;\r\n    margin-bottom: 15px;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .all-users-message.success {\r\n    background-color: #d4edda;\r\n    border: 1px solid #c3e6cb;\r\n    color: #155724;\r\n  }\r\n  \r\n  .all-users-message.error {\r\n    background-color: #f8d7da;\r\n    border: 1px solid #f5c6cb;\r\n    color: #721c24;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
